import { PROJECT_VARIABLES } from './project_variables';
import { AppConstants } from '../app/app.constants';

export const environment = {
    production: false,
    API_SERVER: PROJECT_VARIABLES.api_server.ACCEPTANCE,
    DEFAULT_LOCALE: AppConstants.DEFAULT_LOCALE,
    OAUTH_CLIENT_ID: PROJECT_VARIABLES.oauth_client_id
};
